/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ChatPayload,
} from '../models/index';
import {
    ChatPayloadFromJSON,
    ChatPayloadToJSON,
} from '../models/index';

export interface StreamChatJsonRequest {
    xOrganisation: string;
    chatPayload: ChatPayload;
}

/**
 * 
 */
export class StreamingControllerApi extends runtime.BaseAPI {

    /**
     */
    async streamChatJsonRaw(requestParameters: StreamChatJsonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['xOrganisation'] == null) {
            throw new runtime.RequiredError(
                'xOrganisation',
                'Required parameter "xOrganisation" was null or undefined when calling streamChatJson().'
            );
        }

        if (requestParameters['chatPayload'] == null) {
            throw new runtime.RequiredError(
                'chatPayload',
                'Required parameter "chatPayload" was null or undefined when calling streamChatJson().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xOrganisation'] != null) {
            headerParameters['x-organisation'] = String(requestParameters['xOrganisation']);
        }

        const response = await this.request({
            path: `/api/v2/ai/chat/stream`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChatPayloadToJSON(requestParameters['chatPayload']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async streamChatJson(requestParameters: StreamChatJsonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.streamChatJsonRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
